import React from 'react'
import "./privacyPolicy.scss";
import contact from "../../img/contact.jpg";

export const TermsofService = () => {
    const sections = [
      { id: "intro", title: "1. Introduction" },
      { id: "advice", title: "2. No Financial Advice" },
      { id: "risk", title: "3. Risk Acknowledgement" },
      { id: "liability", title: "4. Liability Limitations" },
      { id: "payments", title: "5. Subscriptions" },
      { id: "brokers", title: "6. Third-Party Platforms" },
      { id: "usage", title: "7. Software Use" },
      { id: "legal", title: "8. Governing Law" },
    ];
  return (
    <div className="__fw">
      <div
        className="contact_head"
        style={{
          backgroundImage: `url(${contact})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="cn_in">
          <h2>
            Terms of <em>Service</em>
          </h2>
        </div>
      </div>

      <div className="__mw">
        <div className="policy_wrp">
          <div className="policy-container">
            {/* Sidebar Navigation */}
            <nav className="policy-sidebar">
              <h4>Legal Terms</h4>
              <ul>
                {sections.map((section) => (
                  <li key={section.id}>
                    <a href={`#${section.id}`}>{section.title}</a>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Main Content */}
            <main className="policy-content">
              <header className="policy-header">
                <p className="effective-date">
                  Effective Date: <span>01.01.2026</span>
                </p>
              </header>

              <section className="intro-card">
                <p>
                  By using <strong>[Your Company Name] FZ-LLC</strong> Services,
                  you agree to be bound by this Agreement. We are a technology
                  provider licensed in a UAE Free Zone.{" "}
                  <strong>
                    We are not a broker, financial adviser, or custodian.
                  </strong>
                </p>
              </section>

              <article id="intro">
                <h2>1. Introduction</h2>
                <p>
                  We provide algorithmic trading software for automation. Our
                  services <strong>do not</strong> constitute investment advice,
                  portfolio management, or custody services.
                </p>
              </article>

              <article id="advice">
                <h2>2. No Financial or Investment Advice</h2>
                <div className="grid-info">
                  <div className="info-block">
                    <h3>Technology Provider</h3>
                    <p>
                      We are not licensed as a broker or investment adviser
                      under UAE law. Our role is strictly technical.
                    </p>
                  </div>
                  <div className="info-block">
                    <h3>Independent Decisions</h3>
                    <p>
                      You are solely responsible for your trading decisions and
                      managing your own risk.
                    </p>
                  </div>
                </div>
              </article>

              <article id="risk" className="warning-section">
                <h2>3. Risk Acknowledgement</h2>
                <div className="alert-box">
                  <p>
                    <strong>High Risk Warning:</strong> Trading involves
                    substantial risk of loss. Past performance does not
                    guarantee future results.
                  </p>
                </div>
                <ul>
                  <li>
                    Software errors, system failures, and connectivity issues
                    are inherent risks.
                  </li>
                  <li>
                    Market volatility and slippage can significantly affect
                    outcomes.
                  </li>
                  <li>
                    We are not responsible for any financial losses or damages.
                  </li>
                </ul>
              </article>

              <article id="liability">
                <h2>4. Limitations of Liability</h2>
                <p>
                  To the maximum extent permitted by UAE law, [Your Company
                  Name] FZ-LLC shall not be liable for:
                </p>
                <ul>
                  <li>Loss of capital or profits.</li>
                  <li>
                    Errors caused by third-party brokers or data providers.
                  </li>
                  <li>Direct or indirect damages arising from software use.</li>
                </ul>
              </article>

              <article id="payments">
                <h2>5. Subscription and Payments</h2>
                <p>Access may require fees as displayed at checkout.</p>
                <div className="grid-info">
                  <div className="info-block">
                    <h3>Setup Fees</h3>
                    <p>May be subject to a limited 30-day refund window.</p>
                  </div>
                  <div className="info-block">
                    <h3>Subscriptions</h3>
                    <p>
                      Recurring fees are generally non-refundable once paid.
                    </p>
                  </div>
                </div>
              </article>

              <article id="brokers">
                <h2>6. Brokerage Accounts</h2>
                <p>
                  All trading activity and fund management occur directly
                  between you and your chosen broker. We do not hold funds or
                  execute trades on your behalf.
                </p>
              </article>

              <article id="usage">
                <h2>7. Use of Our Software</h2>
                <p>
                  You agree not to reverse-engineer, decompile, or use our
                  software for unlawful purposes. You must be at least 18 years
                  of age to use our Services.
                </p>
              </article>

              <article id="legal">
                <h2>8. Governing Law & Disputes</h2>
                <p>
                  This Agreement is governed by{" "}
                  <strong>United Arab Emirates</strong> law. Any disputes shall
                  be resolved through binding arbitration in the UAE.
                </p>
              </article>

              <article id="contact" className="contact-section">
                <h2>Contact Information</h2>
                <div className="contact-card">
                  <p>
                    <strong>[Your Company Name] FZ-LLC</strong>
                  </p>
                  <p>Registered UAE Free Zone</p>
                  <p>
                    Email:{" "}
                    <a href="mailto:[Your Contact Email]">
                      [Your Contact Email]
                    </a>
                  </p>
                </div>
              </article>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
